var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"home"}},[_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":"/logo.svg","alt":"SRC Logo"}}),_c('img',{attrs:{"src":require('./assets/loader.gif'),"alt":"Loading...."}})]),_c('Header'),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }